import {crmAPI,useCRMAuth} from '../../crm/context/CRMAuthContext';
import {ConnectionStatus} from './ConnectionStatus';
export const StaffConnection=({scope='crm'})=>{
  const {user}=useCRMAuth();
  return user?<ConnectionStatus api={crmAPI} scope={scope} identity={`${user.tenant_id}:${user.id}`} />:null;
};